import 'guid/angularModule';
import 'PrioritizedInterceptors/angularModule';
import 'SuperModel';

export default angular.module('UnloadedChangeDetector', ['SuperModel', 'prioritizedInterceptors', 'guid']);
